import { FuseLoadable } from '@fuse';

const ProcessedFluidInvoicing = {
    auth: ['admin', 'sub-admin'],
    routes: [
        {
            exact: true,
            path: '/processed-fluid/invoicing/daily-logs/:id/:selectedDate/:contractId',
            component: FuseLoadable({
                loader: () => {
                    return import('./delivery-logs/DailyLogs');
                },
            }),
        },
        {
            exact: true,
            path: '/processed-fluid/invoicing/invoice-summary/:id',
            component: FuseLoadable({
                loader: () => {
                    return import('./invoice-summary-review/InvoiceSummaryReview');
                },
            }),
        },
        {
            exact: true,
            path: '/processed-fluid/invoicing/charge-items',
            component: FuseLoadable({
                loader: () => {
                    return import('./charge-items/ChargeItems');
                },
            }),
        },
        {
            path: '/processed-fluid/invoicing',
            component: FuseLoadable({
                loader: () => {
                    return import('./ProcessedFluidInvoicing');
                },
            }),
        },
    ],
};

export default [ProcessedFluidInvoicing];
